// extracted by mini-css-extract-plugin
export var gridItem = "styles-module--gridItem--dNYOm";
export var gridItemContent = "styles-module--gridItemContent--k4w9t";